/**
 * Get initials from a name string
 * @param name - The name to get initials from
 * @returns 1-2 character initials in uppercase
 */
export function getInitials(name: string): string {
  if (!name) return "?";

  // Remove emojis
  const nameWithoutEmojis = name
    .replace(
      /[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{1F1E0}-\u{1F1FF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}\u{1F900}-\u{1F9FF}\u{1FA70}-\u{1FAFF}\u{1F200}-\u{1F2FF}\u{1F000}-\u{1F02F}\u{1F0A0}-\u{1F0FF}]/gu,
      ""
    )
    .trim();

  if (!nameWithoutEmojis) return "?";

  const words = nameWithoutEmojis.split(/\s+/);
  if (words.length === 1) {
    return words[0].substring(0, 2).toUpperCase();
  }
  return (words[0][0] + words[words.length - 1][0]).toUpperCase();
}

/**
 * Generate a consistent color class based on name
 * Returns Tailwind classes for background and text color
 * Uses a richer color palette for visual variety
 * @param name - The name to generate color from
 * @returns Tailwind CSS class string
 */
export function getAvatarColor(name: string): string {
  const colors = [
    "bg-emerald-100 text-emerald-700",
    "bg-blue-100 text-blue-700",
    "bg-violet-100 text-violet-700",
    "bg-rose-100 text-rose-700",
    "bg-amber-100 text-amber-700",
    "bg-cyan-100 text-cyan-700",
    "bg-indigo-100 text-indigo-700",
    "bg-teal-100 text-teal-700",
    "bg-fuchsia-100 text-fuchsia-700",
    "bg-sky-100 text-sky-700",
  ];
  // Use a simple hash for better distribution across colors
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  const index = Math.abs(hash) % colors.length;
  return colors[index];
}
